import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {CreateEntityButton} from 'entities/tariff';

interface ICreateDomainMonitorButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const CreateDomainMonitorButton: React.FC<ICreateDomainMonitorButtonProps> = ({onClick, disabled}) => (
    <CreateEntityButton ariaLabel={t`Добавить домен`} onClick={onClick} disabled={disabled}>
        <Trans id="button.add.domainMonitor" message="Добавить домен"/>
    </CreateEntityButton>
);

export default CreateDomainMonitorButton;
